
import React from 'react';
import block from 'bem-cn-lite';
import BlinkingMarker from '../../Components/BlinkingMarker'
const b = block('RequestFormsField');

export default ({label, children, invalid, blink}) => <div className={b()}>
    <label className={b('label', {invalid})}>{label}</label>
    <div className={b('container')}>
        {children}
        {blink && <BlinkingMarker top={47} left={-5}/>}
    </div>
</div>